// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"89df33d2","732":"e458ac98"}[chunkId] + ".chunk.js";
};